<template>
  <jczh-table-content
    :data="tableList"
    :option="tableConfig"
    pagination
    :total="total"
    :page.sync="page"
    :limit.sync="size"
  >
    <!-- 代理服务费 -->
    <template v-slot:agentServiceFee="{ value }">
      <span>{{ value ? `${strToThousands(value)}` : '-' }}</span>
      <money-in-cn :money="value" />
    </template>

    <template v-slot:last>
      <el-table-column label="操作" align="center" width="100" fixed="right">
        <template slot-scope="{ row }">
          <el-button class="info-button" type="text" @click="handleLook(row)">
            查看详情
          </el-button>
        </template>
      </el-table-column>
    </template>
  </jczh-table-content>
</template>

<script>
// 组件
import MoneyInCn from '@/components/common/MoneyInCn'

// 后端api
import { getBiddingRegistrationListApi } from '@/api/procure/invite-bid'

// 数据字典
import { projectTypeDict } from '@/dictionary/project/common'
import { queryMethodDict } from '@/dictionary/query-status'

// mixins
import listFilterMixin from '@/mixins/list-filter-mixin'

// 工具
import { strToThousands } from '@/utils/utils'

export default {
  name: 'BiddingRecordTable',

  components: {
    MoneyInCn
  },

  mixins: [listFilterMixin],

  props: {
    // 是否是委托采购
    isEntrust: {
      type: Boolean,
      default: false
    },

    // 项目登记id
    projectId: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      // 表格数据
      total: 0,
      tableList: []
    }
  },

  computed: {
    tableConfig() {
      return [
        { label: '招标名称', prop: 'orderName', minWidth: 150 },
        {
          label: '项目类型',
          prop: 'biddingType',
          filter: value => projectTypeDict.translate(value).label || ' - ',
          minWidth: 130
        },
        {
          label: '招标估算(万元)',
          prop: 'budget',
          filter: value => (value ? strToThousands(value) : '-'),
          minWidth: 140
        },
        {
          label: '经办人',
          prop: 'releasePeople',
          minWidth: 100
        },
        {
          label: '发布日期',
          prop: 'releaseTime',
          minWidth: 140,
          isNormDay: true
        }
      ]
    }
  },

  methods: {
    strToThousands,
    /**
     * 获取列表
     */
    async getList() {
      getBiddingRegistrationListApi({
        entrustProjectId: this.projectId,
        filterStatusJoin: '1',
        page: this.page,
        size: this.size
      })
        .then(res => {
          this.tableList = res.data?.records || []
          this.total = res.data?.total || 0
        })
        .catch(err => {
          this.$message.error(err.message || '获取列表失败')
        })
    },

    /**
     * 跳转到详情页
     */
    handleLook(row) {
      this.$router.push({
        name: 'RegisterBiddingRecordProjectDetail',
        params: {
          orderId: row.registrationId
        }
      })
    }
  }
}
</script>

<style></style>
